import styled from 'styled-components';
import {
  fontFamilySecondary,
  fontFamilyPrimary,
  colorBlack900,
  mediaQueryMobileLargeMin,
  colorAccentLighten95,
  colorGrey400,
} from 'styles';
import { Wrapper as SectionWrapper } from 'components/CurrencyExchangeTable/styles';

export const Wrapper = styled(SectionWrapper)`
  padding: 16px 0 16px 16px;
  position: relative;

  @media all and ${mediaQueryMobileLargeMin} {
    padding: 24px 0 24px 24px;
  }
`;

export const Slide = styled.div`
  display: flex;
  flex-direction: column;
  margin-right: 12px;
  background: #f6f5f8;
  overflow: hidden;
  border-radius: 4px;
  min-width: 198px;
  max-width: 198px;
  height: 266px;
`;

export const SliderWrapper = styled.div`
  display: flex;
  overflow: scroll;

  &::-webkit-scrollbar {
    display: none;
  }
`;

export const SlideButtonRight = styled.button`
  display: none;
  position: absolute;
  top: 50%;
  right: 20px;
  width: 48px;
  height: 48px;
  padding-right: 5px;
  border: none;
  border-radius: 50%;
  box-shadow: 0px 4px 8px rgba(0, 0, 0, 0.16);
  background: #fff;
  z-index: 2;

  &:hover {
    background: #f4f4f4;
  }
  &:active {
    background: #f2f2f2;
  }

  @media all and ${mediaQueryMobileLargeMin} {
    display: block;
  }
`;

export const SlideButtonLeft = styled(SlideButtonRight)`
  left: 36px;
  padding-left: 1px;
`;

export const ShadowRight = styled.div`
  position: absolute;
  top: 0;
  right: 0;
  height: 100%;
  width: 32px;
  background: linear-gradient(270deg, #ffffff 0%, rgba(255, 255, 255, 0) 100%);
  z-index: 1;
`;

export const ShadowLeft = styled(ShadowRight)`
  left: 0;
  background: linear-gradient(
    90deg,
    #ffffff 0%,
    rgba(255, 255, 255, 0) 100%
  ) !important;
`;

export const Title = styled.h2`
  font-family: ${fontFamilySecondary};
  font-size: 18px;
  line-height: 24px;
  color: ${colorBlack900};
  margin-bottom: 24px;

  @media all and ${mediaQueryMobileLargeMin} {
    font-size: 20px;
    line-height: 28px;
  }
`;

export const Video = styled.div`
  display: flex;
  background: ${({ img }) => `url(${img})`};
  justify-content: center;
  align-items: center;
  width: 100%;
  height: 111px;
  background-size: cover;
  background-position: center;
`;

export const VideoMeta = styled.div`
  padding-bottom: 5px;
  flex: 1;
  display: flex;
  justify-content: space-between;
  flex-direction: column;
`;

export const PlayBtn = styled.button`
  border: none;
  background: none;
`;

export const CloseBtn = styled.button`
  display: block;
  background: none;
  color: #fff;
  border: none;
  margin-left: auto;
  font-size: 30px;
  padding: 0;
  margin-bottom: 5px;
  position: absolute;
  right: 0;
  top: -42px;
  width: 40px;
  height: 40px;

  @media all and ${mediaQueryMobileLargeMin} {
    right: 52px;
  }
`;

export const Text = styled.p`
  font-family: ${fontFamilyPrimary};
  color: ${colorBlack900};
  font-size: 14px;
  line-height: 20px;
  padding: 12px;
`;

export const Date = styled.span`
  color: #87928c;
  font-size: 13px;
  line-height: 16px;
  font-family: ${fontFamilyPrimary};
  margin-left: 12px;
`;

export const Modal = styled.div`
  position: fixed;
  display: flex;
  justify-content: center;
  align-items: center;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  margin: auto;
  background: rgba(0, 0, 0, 0.4);
  z-index: 99;
`;

export const VideoWrapper = styled.div`
  position: relative;
  & iframe {
    width: 100vw;
    height: 100vw;
    max-width: 100%;
    @media all and ${mediaQueryMobileLargeMin} {
      width: 70vw;
      height: 70vh;
    }
  }
`;

export const SliderContainer = styled.div`
  position: relative;
`;

export const AuthorLink = styled.a`
  display: flex;
  margin-top: 12px;
  border-radius: 4px;
  padding: 16px;
  background: ${colorAccentLighten95};
  margin-right: 16px;
  align-items: center;

  & > svg {
    margin-left: auto;
  }
`;

export const AuthorWrapper = styled.div`
  display: flex;
`;
export const AuthorImg = styled.img`
  width: 40px;
  height: 40px;
  border-radius: 50%;
  margin-right: 12px;
`;
export const AuthorDesc = styled.div`
  font-size: 13px;
  line-height: 16px;
  color: ${colorGrey400};
`;
export const AuthorTitle = styled.div`
  font-family: ${fontFamilySecondary};
  font-weight: 700;
  font-size: 14px;
  line-height: 24px;
  color: ${colorBlack900};
`;
export const AuthorName = styled.div`
  display: flex;
  flex-direction: column;
`;
